import React from "react";
import contact from "../assets/contact.gif";
import linkedin from "../assets/linkedin.gif";
import "../styles/contact.scss";
export default function Contact() {
  return (
    <div className="contactWrapper">
      <div
        className="contactGif"
        style={{
          background: `url(${contact}) no-repeat`,
        }}
        data-aos="zoom-in-down"
      ></div>
      <div data-aos="zoom-in-left">
        <div style={{ fontSize: 18 }}>
          <b>Arvind S</b>
        </div>
        <br />
        <div>Ashok Pillar, Chennai, Tamil Nadu, India</div>
        <br />
        <div>arvinds2605@gmail.com</div>
        <br />
        <div>+91 9087602532</div>
        <div style={{ marginTop: 10 }}>
          <a
            href="https://www.linkedin.com/in/arvind-suriya/"
            target="_blank"
            rel="noreferrer"
          >
            <img src={linkedin} height={40} width={40} alt={"linkedin"} />
          </a>
        </div>
      </div>
    </div>
  );
}
